import React from 'react'
import { WithTranslation } from 'react-i18next'
import { FiArrowRight } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { useSelector } from 'react-redux'
import { is } from '../MediaQuery'
import Button from '../Template/Button'
import { CredentialsStorage } from '../../database/localStorage/names'
import { driver } from '../../database/localStorage'
import promoBannerPL from '../../assets/promotion/spring2026/PL.png'
import promoBannerEN from '../../assets/promotion/spring2026/EN.png'

import {
  getUserId,
  getUserLanguage,
} from '../../reducers/userAccount/selectors/userAccount'
//getUserPremiumUsed
import Label from './Label'
import ButtonWrapper from './ButtonWrapper'
import Bar from './Bar'
import { Mixpanel } from '../../utils/Mixpanel'
import { getPanelUrlForEnv } from '../../utils/ApiUrl'
import { isTrialAccount } from '../../reducers/userAccount/selectors/license'

function PremiumBar({
  t,
  licenseValid,
  isWithShadow,
  size = 1,
  margin = true,
  source = 'calendar',
}: WithTranslation & IPremiumBarProps) {
  const txt = t('info_payment_text_goto_html').replace(/<[^>]+>/g, '')
  const isDesktop = is.desktop()
  const userId = useSelector(getUserId)

  function goToPremium() {
    Mixpanel.people.increment(userId, 'Premium Menu Opened', 1)
    Mixpanel.track('Main Menu Premium Item Used', {})
    const key = driver.getItem(CredentialsStorage.AccessToken, '')
    //var EnvUrl = getApiUrlForEnv()
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
  }

  const key = driver.getItem(CredentialsStorage.AccessToken, '')
  const start = 1787562797
  const today = Math.floor(Date.now() / 1000)
  const end = 1788134399

  let showPromotion = today > start && today < end ? true : false
  const lang = useSelector(getUserLanguage)
  const isTrial = useSelector(isTrialAccount)

  
  let promoBanner = promoBannerEN
  if (lang === 'pl' || lang === 'pl_PL') {
    promoBanner = promoBannerPL
  }

/* else if (lang === 'de') {
    promoBanner = promoBannerDE
  } else if (lang === 'it') {
    promoBanner = promoBannerIT
  } else if (lang === 'es') {
    promoBanner = promoBannerES
  } else if (lang === 'el') {
    promoBanner = promoBannerEL
  } else if (lang === 'pt' || lang === 'pt_BR') {
    promoBanner = promoBannerPT
  } else if (lang === 'fr') {
    promoBanner = promoBannerFR
  }*/

  if (showPromotion && isTrial) {
    licenseValid = false
  }
  let urlPremium = `https://panel.bed-booking.com/index/login?autologinkey=${key}&redirect=/payment/index/`
  return showPromotion ? (
    <div
      style={{
        backgroundColor: isWithShadow ? '#ffffff' : '#ebedef',
        //boxShadow: isWithShadow ? '0px 8px 17px -17px black' : 'none',
        display: licenseValid ? 'none' : 'block',
        marginBottom: margin ? `${1.5 * size}em` : '0px',
        width: '100%',
      }}
    >
      <a href={urlPremium}>
        <img
          src={promoBanner}
          style={{ display: 'block', maxWidth: '100%', margin: '0px auto' }}
          alt="promo"
        />
      </a>
    </div>
  ) : (
    <Flex
      full={true}
      alignCenter={true}
      row={true}
      style={{
        backgroundColor: 'white',
        boxShadow: isWithShadow ? '0px 8px 17px -17px black' : 'none',
        display: licenseValid ? 'none' : 'flex',
        marginBottom: margin ? `${1.5 * size}em` : '0px',
        maxHeight: !isDesktop ? `${80 * size}px` : `${120 * size}px`,
        overflow: 'hidden',
      }}
    >
      <Flex>
        <Bar size={size} />
      </Flex>
      <ButtonWrapper size={size}>
        <Flex alignCenter={true}>
          <Button
            size={size}
            style={{
              height: !isDesktop ? `${38 * size}px` : `${60 * size}px`,
              transition: 'none',
              width: !isDesktop ? `${190 * size}px` : `${406 * size}px`,
            }}
            primary={true}
            onClick={goToPremium}
          >
            <Label size={size}>{txt}</Label>
            {isDesktop && (
              <FiArrowRight
                style={{ marginLeft: `${10 * size}px` }}
                size={26 * size}
              />
            )}
          </Button>
        </Flex>
      </ButtonWrapper>
    </Flex>
  )
}

export default PremiumBar

export interface IPremiumBarProps {
  licenseValid?: boolean
  margin?: boolean
  isWithShadow?: boolean
  token?: string
  size?: number
  source?: string
}
